import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  constructor() {}

  isProfile(profile: string): boolean {
    let permitted = false;

    if (environment.user) {
      const profileName = environment.user.novoPerfil.nome;

      if (profileName === profile) {
        permitted = true;
      }
    }

    return permitted;
  }

  isPermitted(module: string): boolean {
    let permitted = false;

    if (environment.user && environment.selected) {
      const companies = environment.user.empresas;
      const permissions = environment.user.novoPerfil.permissoes.painel;
      const companySelected = companies.filter(company => company.cnpj === environment.selected.cnpj);

      if (companySelected) {
        const mod = permissions.find(mod => mod.codigo === module);

        if (mod) {
          permitted = mod.permitido;
        }
      }
    }

    return permitted;
  }
}
